// extracted by mini-css-extract-plugin
export default {"wrapper":"T9-z","play":"U9-z"};